import { useState } from "react";

import { Product } from "Hooks/useProducts/interface";
import { FakePromise } from "Utils/Promise";
import { createToast } from "Utils/toastFunc";
import { STATUS } from "Constants/Combos";
import { useItemsContext } from "./useItemsContext";

export const useCartAmount = () => {
  const [modal, setModal] = useState({
    alerts: false,
  });
  const [preparation, setPreparation] = useState("");
  const [preparationConfirmCallback, setPreparationConfirmCallback] = useState<{
    resolved: (() => void) | null;
    rejected: (() => void) | null;
  }>({ rejected: null, resolved: null });

  const closeModal = (modalClose: "alerts") => {
    setModal((prev) => ({ ...prev, [modalClose]: false }));
  };

  const { addItem, deleteItem } = useItemsContext();

  const checkPreparation = (prep: string) => {
    return new Promise((resolve, reject) => {
      setModal((prev) => ({ ...prev, alerts: true }));
      setPreparation(prep);
      setPreparationConfirmCallback({
        rejected: () => reject("Adição cancelada"),
        resolved: () => resolve(""),
      });
    });
  };

  const handleAddProduct = async (product: Product) => {
    try {
      if (product.status.id === STATUS.unavaliable) {
        createToast("error", "Este produto não está disponível no momento");
        return;
      }
      if (product.product_description?.budget_obs) {
        await checkPreparation(product.product_description.budget_obs);
      }
      await FakePromise(1000);

      addItem({
        product_id: product.id,
        product_code: product.sku,
        product_name: product.product,
        amount: 1,
        product_price: product.default_partner.price,
      });
      createToast("success", "Produto adicionado com sucesso!");
    } catch (error) {
      createToast("error", "Não foi possível adicionar este item");
    }
  };

  const handleRemoveToCart = async (product: Product) => {
    await FakePromise(1000);
    deleteItem(product.id);
  };

  return {
    handleRemoveToCart,
    handleAddProduct,
    closeModal,
    modal,
    preparation,
    preparationConfirmCallback,
    setPreparationConfirmCallback,
  };
};
